import {useTheme} from 'react-jss';
import {useEffect, useState} from 'react';
import SkeletonBox from '../../../UI/SkeletonBox/SkeletonBox';
import setContrastColorBasedOnBackground from '../../style-helper/setContrastColorBasedOnBackground';
import GenericFallbackSuspense from '../ui/GenericFallback/GenericFallbackSuspense';
import getLogo from './getLogo';

const DynamicLogo = () => {
  const [dynamicLogo, setDynamicLogo] = useState(null);
  const textHex = setContrastColorBasedOnBackground(useTheme().footer.backgroundColour);
  
  useEffect(() => {
    getLogo(textHex).then(setDynamicLogo);
  }, [textHex]);
  
  if (!dynamicLogo) return null;
  return (
    <GenericFallbackSuspense fallback={<SkeletonBox height={30} width={70} />}>
      {dynamicLogo}
    </GenericFallbackSuspense>
  );
};

export default DynamicLogo;
